import React from 'react';
import css from './ProfilePage.module.css';
import { FormattedMessage } from 'react-intl';
import Icons from '../../components/Icons/Icons';
import { H4 } from '../../components';
import {
  siteGradientOptions,
  planningPermissionOptions,
  serviceOptions,
  sustainabilityRequirementsOptions,
  yesNoOptions,
} from '../../util/general';
import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';

const renderSingleValue = (headingId, value, options) => {
  if (!value) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {getLabelFromKey(value, options)}
        </div>
      </div>
    </>
  );
};

const renderRawValue = (headingId, value) => {
  if (!value) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        <div className={css.service}>
          <Icons name="check" /> {value}
        </div>
      </div>
    </>
  );
};

const renderArraySection = (headingId, keys, options) => {
  if (!isArrayLength(keys)) return null;
  return (
    <>
      <H4 as="h4">
        <FormattedMessage id={headingId} />
      </H4>
      <div className={css.serviceList}>
        {keys.map((key, i) => (
          <div key={i} className={css.service}>
            <Icons name="check" /> {getLabelFromKey(key, options)}
          </div>
        ))}
      </div>
    </>
  );
};

const PlotInformationSection = ({ publicData = {} }) => {
  const {
    address,
    hasSite,
    siteDescription,
    siteGradient,
    siteLocation,
    planningPermissionObtained,
    supportWanted,
    sustainabilityRequirements,
    number_of_bathrooms,
    number_of_bedrooms,
    number_of_storeys,
    size_of_dining_room,
    size_of_family_room,
    size_of_garage,
    size_of_kitchen,
    size_of_lounge,
    size_of_office,
  } = publicData;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.plotInformation" />
      </h2>

      {renderRawValue('ProfilePage.address', address)}
      {renderSingleValue('ProfilePage.hasSite', hasSite, yesNoOptions)}
      {renderRawValue('ProfilePage.siteDescription', siteDescription)}
      {renderSingleValue('ProfilePage.siteGradient', siteGradient, siteGradientOptions)}
      {renderRawValue('ProfilePage.siteLocation', siteLocation)}
      {renderSingleValue(
        'ProfilePage.planningPermission',
        planningPermissionObtained,
        planningPermissionOptions
      )}
      {renderArraySection('ProfilePage.supportWanted', supportWanted, serviceOptions)}
      {renderArraySection(
        'ProfilePage.sustainabilityRequirements',
        sustainabilityRequirements,
        sustainabilityRequirementsOptions
      )}

      {renderRawValue('ProfilePage.number_of_storeys', number_of_storeys)}
      {renderRawValue('ProfilePage.number_of_bedrooms', number_of_bedrooms)}
      {renderRawValue('ProfilePage.number_of_bathrooms', number_of_bathrooms)}

      {renderRawValue('ProfilePage.size_of_kitchen', size_of_kitchen)}
      {renderRawValue('ProfilePage.size_of_lounge', size_of_lounge)}
      {renderRawValue('ProfilePage.size_of_dining_room', size_of_dining_room)}
      {renderRawValue('ProfilePage.size_of_family_room', size_of_family_room)}
      {renderRawValue('ProfilePage.size_of_office', size_of_office)}
      {renderRawValue('ProfilePage.size_of_garage', size_of_garage)}
    </div>
  );
};

export default PlotInformationSection;
